// react
import { useState, useEffect } from "react";
import axios from "axios";
import { useForm, SubmitHandler, FieldValues } from "react-hook-form";
// mui
import { Button, TextField, Stack, Modal, Box } from "@mui/material";
// components
import { RESPONSE_STATUS } from "src/config/service";
import { MAPPING_GOTO } from "src/config/service";
import user from "src/components/UI/Shared/user";
// assets
import styles from "src/components/Verify/assets/scss/verfiy.module.scss";
// redux
import { useSelector, useDispatch } from "react-redux";
import { appActions } from "src/store/store";

const Verify = () => {
  const dispatch = useDispatch();
  const trackingData = useSelector((state: any) => state.app.trackingData);

  const [captcha_img, setCaptcha_img] = useState("");
  const [goto, setGoto] = useState("");
  const [missMatch, setMissMatch] = useState(false);
  const apiURL = process.env.REACT_APP_API_URL || "";

  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm({
    mode: "onChange",
  });
  const handleSubmit_: SubmitHandler<FieldValues> = async (data) => {
    const ip = user.parseUserIp();

    const formData = new FormData();
    formData.append("ip", ip);
    formData.append("result", data.result);

    const endpointUrl = "user/verify_challenge/";
    try {
      await axios.post(apiURL + endpointUrl, formData).then((response) => {
        setValue("result", "");

        dispatch(
          appActions.setTrackingData({
            ...trackingData,
            serviceStatus: response.data["verification_status"],
          })
        );
        if (response.data["verification_status"] === RESPONSE_STATUS.ACTIVE) {
          console.log("active, ", goto);
          window.location.href = goto;
        } else if (
          response.data["verification_status"] === RESPONSE_STATUS.BLOCKED
        ) {
          console.log("blocked, ", goto);
          console.log(goto === "../../");
          console.log(
            (window.location.href = goto === "../../" ? goto : "/Geo/")
          );
          dispatch(
            appActions.setSearchString({
              menu1: "",
              menu2: "",
              menu3: "",
              menu4: "",
              menu5: "",
              menu6: "",
            })
          );
          dispatch(appActions.setActivePanel(undefined));
          window.location.href = goto === "../../" ? goto : "/Geo/";

          dispatch(
            appActions.setNotification({
              severity: "error",
              message:
                "Service cap reached today! Take a breather and come back for more fun tomorrow!",
              open: true,
            })
          );
        } else if (
          response.data["verification_status"] === RESPONSE_STATUS.VERIFY
        ) {
          setMissMatch(true);
        }
      });
    } catch (error) {
      dispatch(
        appActions.setNotification({
          severity: "error",
          message: "error",
          open: true,
        })
      );
    }
  };
  useEffect(() => {
    const current_user = user.getCurrentLoggedIn();
    const data = localStorage.getItem(current_user);
    const _info = data !== null ? JSON.parse(data) : null;
    console.log(_info.ip_data.guid);
    setCaptcha_img(_info.ip_data.guid);
    console.log(MAPPING_GOTO[_info.ip_data.map]);
    setGoto(MAPPING_GOTO[_info.ip_data.map]);
  }, []);
  return (
    <>
      <Modal
        open={true}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        className={styles.backdrop}
      >
        <Box className={styles.box}>
          <Stack spacing={5} alignItems={"flex-start"} sx={{ p: 0.75 }}>
            <img src={apiURL + captcha_img} />
            <TextField
              {...register("result", {
                required: "Result is required.",
                valueAsNumber: true,
              })}
              className={styles.textField}
              name="result"
              label="Solve the problem.."
              variant="outlined"
              error={!!errors.result || missMatch}
              helperText={
                missMatch ? "Try again." : errors.result?.message?.toString()
              }
            />
            <Button
              variant="outlined"
              onClick={handleSubmit(handleSubmit_)}
              className={`${styles.button}  `}
              disabled={Boolean(errors.result)}
            >
              Submit
            </Button>
          </Stack>
        </Box>
      </Modal>
    </>
  );
};
export default Verify;
